<template>
    <div class="foot">
       <div class="foot-icon"><LogoIcon style="height:1rem;margin-top:-0.3rem;"/></div>
       <div class="foot-text">Vocation - {{ year }}</div> 
    </div>
</template>
<script>
import LogoIcon from '@/components/IconComponents/LogoIcon.vue';
    export default{
       components:{
        LogoIcon
       },
        data(){
            return{
            year: new Date().getFullYear()
            }
        }
        
    }
</script>
<style scoped>
    .foot{
        margin-top: auto;
        padding:0.5rem 0.6rem;
        font-size: 0.9rem;
        background-color: var(--footer);
        color:white;
        display: flex;
    }

    .foot-text{
        color:var(--footer-text);
    }

    @media(max-width:768px) {
        .foot{
            padding:0.7rem;
            font-size: 0.8rem;
            justify-content: center;
            /* text-align: center; */
        }
    }
</style>